/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CatalogueBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CatalogueBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.CatalogueBean = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.CatalogueBean);
  }
}(this, function(ApiClient, CatalogueBean) {
  'use strict';

  /**
   * The CatalogueBean model module.
   * @module model/CatalogueBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>CatalogueBean</code>.
   * @alias module:model/CatalogueBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>CatalogueBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CatalogueBean} obj Optional instance to populate.
   * @return {module:model/CatalogueBean} The populated <code>CatalogueBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = CatalogueBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {module:model/CatalogueBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/CatalogueBean.js